import { render, staticRenderFns } from "./edit_address.vue?vue&type=template&id=85209698&scoped=true&"
import script from "./edit_address.vue?vue&type=script&lang=js&"
export * from "./edit_address.vue?vue&type=script&lang=js&"
import style0 from "./edit_address.vue?vue&type=style&index=0&id=85209698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85209698",
  null
  
)

export default component.exports